export default "__VITE_ASSET__BIWALrc9__"